export const ONBOARDING_LINKS = {
  ONBOARDING_LINK_ACCOUNT_VERIFY: `${
    import.meta.env.VITE_DEEP_ONBOARDING_BASE_URL
  }/account/verify`,
  ONBOARDING_LINK_ACCOUNT: `${
    import.meta.env.VITE_DEEP_ONBOARDING_BASE_URL
  }/account`,
}

export const ONBOARDING_QUERY_TYPES = {
  ONBOARDING_QUERY_TYPE_DEEPBOX: 'deepbox',
  ONBOARDING_QUERY_TYPE_DEEPV: 'deepv',
  ONBOARDING_QUERY_TYPE_DEEPSIGN: 'deepsign',
}

export const ONBOARDING_COMPANY_VERIFICATION_STATUS = {
  ONBOARDING_COMPANY_VERIFICATION_STATUS_NONE: 'none',
  ONBOARDING_COMPANY_VERIFICATION_STATUS_MANUAL_OVERRIDE: 'manual_override',
  ONBOARDING_COMPANY_VERIFICATION_STATUS_VERIFIED: 'verified',
  ONBOARDING_COMPANY_VERIFICATION_STATUS_INPROGRESS: 'inprogress',
  ONBOARDING_COMPANY_VERIFICATION_STATUS_VALIDATION_ERROR: 'validation_error',
}

export const VERIFICATION_STATES = {
  VERIFICATION_STATE_NONE: 'none',
  VERIFICATION_STATE_WEAK: 'weak',
  VERIFICATION_STATE_STRONG: 'strong',
}

export const VERIFICATION_PROCESS_TYPES = {
  VERIFICATION_PROCESS_TYPE_STARTED: 'started',
  VERIFICATION_PROCESS_TYPE_IN_PROGRESS: 'in_progress',
  VERIFICATION_PROCESS_TYPE_ERROR: 'error',
}

export const VERIFIED_VERIFICATION_STATES = [
  VERIFICATION_STATES.VERIFICATION_STATE_WEAK,
  VERIFICATION_STATES.VERIFICATION_STATE_STRONG,
]
